import React from "react";
import ConnectedPrivacyOptions from "../Pages/PaymentPage/ConnectedPrivacyOptions";
import ConnectedSystemFieldGroupPrivacyOptions from "../Pages/PaymentPage/ConnectedSystemFieldGroupPrivacyOptions";

/**
 * @param {object} props - Component properties
 * @param {number} props.controlId - The ID of the CMS control to retrieve settings
 * @param {boolean} props.shouldUseInvertedOptions - Whether or not to use the inverted component
 * @returns {React.ReactElement} The PrivacyOptionsControl component.
 */
const PrivacyOptionsControl = ({ controlId, shouldUseInvertedOptions }) => (
    <div>
        {shouldUseInvertedOptions ? (
            <ConnectedSystemFieldGroupPrivacyOptions controlId={controlId} />
        ) : (
            // TODO: This is only used on P2P Registrations that are not using the
            // new OneForm for donations.  It should be removed once all P2P Registrations
            // are using the new OneForm.
            <div className="grid">
                <ConnectedPrivacyOptions controlId={controlId} />
            </div>
        )}
    </div>
);

export default PrivacyOptionsControl;
